import { useSelector } from 'react-redux'

import { currentUserSelfAccountsListSelector } from '../../../modules/selectors/app'

export default function useInternalAdSelfAccountName(ad) {
  const selfAccounts = useSelector(currentUserSelfAccountsListSelector)

  return selfAccounts.find(({ id }) => Number(id) === Number(ad.account_id))?.name || ''
}
